import { render, staticRenderFns } from "./saveOrShareMarker.vue?vue&type=template&id=227df428&scoped=true"
import script from "./saveOrShareMarker.vue?vue&type=script&lang=js"
export * from "./saveOrShareMarker.vue?vue&type=script&lang=js"
import style0 from "./saveOrShareMarker.vue?vue&type=style&index=0&id=227df428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227df428",
  null
  
)

export default component.exports